/**
 * Purpose:
 * Resolve which shell layout should wrap the authenticated dashboard routes.
 * Why:
 * Layout selection belongs in one place so tenant defaults and future
 * user-specific overrides can evolve without scattering conditions.
 */
import { Injectable } from '@angular/core';
import { LoggingService } from '@app/core/services';
import { AccountAccessService } from '@modules/navigation/services/account-access.service';
import { AppLayoutType, APP_LAYOUTS } from '@modules/navigation/models';

@Injectable({ providedIn: 'root' })
export class AppLayoutService {
    constructor(
        private readonly accountAccessService: AccountAccessService,
        private readonly loggingService: LoggingService
    ) {}

    isUserSimpleLayoutUser(): boolean {
        return this.accountAccessService.isApiTenantUser();
    }

    resolveDashboardLayout(): AppLayoutType {
        const layout = this.accountAccessService.getPreferredLayout();
        this.loggingService.debug('[AppLayoutService] Resolved dashboard layout.', { layout });
        return layout === APP_LAYOUTS.USER_SIMPLE ? APP_LAYOUTS.USER_SIMPLE : APP_LAYOUTS.TENANT_DASHBOARD;
    }
}
